import { SearchOffers } from '@lambda/commons/apis/elasticsearch/types';
import { categoryNameToHandle } from '@lambda/reebelo/src/commonHelpers';
import Section from '@/components/commons/Section';
import Slider from '@/components/slider/Slider';
import ProductCard from './ProductCard';
import { breakpoints } from '@/lib/collections/category/helpers';
import ViewAll from '../commons/Carousel/ViewAll';

const BestSellers = ({
  offers,
  title,
  name,
  categoryPk,
}: {
  offers: SearchOffers[];
  title: string;
  name: string;
  categoryPk: string;
}) => {
  const sectionTitle = `Best Sellers ${title} Products`;
  const categoryHandle = categoryNameToHandle(name);
  const link = `/collections/${categoryHandle}/${categoryPk}`;

  return (
    <Section className="reebelo-container pt-8">
      <div>
        <h2 className="flex items-center text-lg font-semibold md:text-xl">
          {sectionTitle}
        </h2>
      </div>
      <div className="relative">
        <Slider breakpoints={breakpoints} className="mt-2">
          {offers.map((offer) => (
            <ProductCard offer={offer} key={offer.key} />
          ))}
          <ViewAll title={title} link={link} />
        </Slider>
      </div>
    </Section>
  );
};

export default BestSellers;
